import React, { FC } from 'react'

import { ChevronRightIcon } from '@heroicons/react/20/solid'

import { useAppSelector } from '@/client/hooks'
import { ROOT_FOLDERS } from '@/features/FileManager/fileManagerSlice'

export const Breadcrumbs: FC = () => {
  const selectedFolder = useAppSelector((state) => state.fileManager.selectedFolder)
  const selectedParentFolder = useAppSelector((state) => state.fileManager.selectedParentFolder)

  let level1Folder = ''

  if (!ROOT_FOLDERS.includes(selectedFolder)) {
    level1Folder = selectedFolder
  }

  return (
    <div className='flex items-center justify-start w-[calc(100%_-_200px)]'>
      <div className='text-ellipsis overflow-hidden whitespace-nowrap'>
        {selectedParentFolder || selectedFolder}
        {level1Folder && (
          <>
            <ChevronRightIcon
              width={20}
              className='mx-1 min-w-[20px] inline-block'
            />
            {level1Folder}
          </>
        )}
      </div>
    </div>
  )
}
